import { useMemo } from 'react';
import { Text } from '@optiaxiom/react';

import * as styles from './HighlightedText.css';

type HighlightedTextProps = {
  text: string;
  highlight: string;
  className?: string;
};

export function HighlightedText({ text, highlight, className }: HighlightedTextProps) {
  const parts = useMemo(() => {
    if (!highlight) {
      return [];
    }

    const result: Array<{ text: string; match: boolean; offset: number }> = [];
    const lowerText = text.toLowerCase();
    const lowerHighlight = highlight.toLowerCase();
    let lastIndex = 0;
    let index = lowerText.indexOf(lowerHighlight, lastIndex);

    while (index !== -1) {
      if (index > lastIndex) {
        result.push({ text: text.slice(lastIndex, index), match: false, offset: lastIndex });
      }
      result.push({
        text: text.slice(index, index + highlight.length),
        match: true,
        offset: index,
      });
      lastIndex = index + highlight.length;
      index = lowerText.indexOf(lowerHighlight, lastIndex);
    }

    if (lastIndex < text.length) {
      result.push({ text: text.slice(lastIndex), match: false, offset: lastIndex });
    }

    return result;
  }, [text, highlight]);

  if (!highlight) {
    return (
      <Text lineClamp="1" className={className}>
        {text}
      </Text>
    );
  }

  return (
    <Text lineClamp="1" className={className}>
      {parts.map(part =>
        part.match ? (
          <mark key={part.offset} className={styles.highlightMark}>
            {part.text}
          </mark>
        ) : (
          part.text
        )
      )}
    </Text>
  );
}
